import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalResult } from '../models';

enum Size {
  small = 'sm',
  medium = 'lg',
  large = 'xl',
  xl = 'full',
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  modals: NgbModalRef[] = [];

  private config = {
    backdrop: 'static',
    keyboard: false,
  } as NgbModalOptions;

  constructor(private modalService: NgbModal) {}

  get modalLevel(): number {
    return this.modals.length;
  }

  openSmall<T>(component: any): ModalResult<T> {
    return this.open(component, Size.small);
  }

  openMedium<T>(component: any): ModalResult<T> {
    return this.open(component, Size.medium);
  }

  openLarge<T>(component: any): ModalResult<T> {
    return this.open(component, Size.large);
  }

  openXL<T>(component: any): ModalResult<T> {
    return this.open(component, Size.xl);
  }

  close(data?: any) {
    this.modal.close(data);
    this.removeModal();
  }

  dismiss(data?: any) {
    this.modal.dismiss(data);
    this.removeModal();
  }

  get anyModalsOpen(): boolean {
    return this.modalService.hasOpenModals();
  }

  private open<T>(component: any, size: Size): ModalResult<T> {
    this.modals.push(this.modalService.open(component, { ...this.config, size }));
    return { modal: this.modal, component: this.modal.componentInstance };
  }

  private get modal() {
    return this.modals[this.modals.length - 1];
  }

  private removeModal() {
    this.modals = this.modals.slice(0, this.modals.length - 1);
  }
}
